export const MARKETING_COLORS_BRAND = {
    midnight: { code: "#2f3a53", mode: { dark: true, standard: false }, displayName: "Midnight" },
    warmWhite: { code: "#f6f6ec", mode: { dark: false, standard: true }, displayName: "Warn White" },
    white: { code: "#ffffff", mode: { dark: false, standard: true }, displayName: "White" },
    vistaBlue: { code: "#6fd0f5", mode: { dark: false, standard: true }, displayName: "Vista Blue" },
    black900: { code: "#000000", mode: { dark: true, standard: false }, displayName: "Black" },
};
export const SEASONAL_FY25Q3 = {
    softSunkissed: {
        code: "#f3cb72",
        mode: { dark: false, standard: true },
        displayName: "Soft-Sunkissed",
    },
    mainPeach: { code: "#ffb08c", mode: { dark: false, standard: true }, displayName: "Main-Peach" },
    deepAperol: {
        code: "#ee6e58",
        mode: { dark: false, standard: true },
        displayName: "Deep-Aperol",
    },
    accentJade: {
        code: "#4eae71",
        mode: { dark: false, standard: true },
        displayName: "Accent-Jade",
    },
};
export const MARKETING_COLORS_HOLIDAY = {
    holiday: { code: "#9a0202", mode: { dark: true, standard: false }, displayName: "Holiday" },
    green2: { code: "#06462e", mode: { dark: true, standard: false }, displayName: "Green2" },
    green1: { code: "#50af60", mode: { dark: false, standard: true }, displayName: "Green1" },
    red1: { code: "#8b0d13", mode: { dark: true, standard: false }, displayName: "Red1" },
    red2: { code: "#8b0d13", mode: { dark: true, standard: false }, displayName: "Red2" },
    beige1: { code: "#ede3cf", mode: { dark: false, standard: true }, displayName: "Beige1" },
};
export const MARKETING_COLORS_CORE = {
    rum: {
        code: "#c94b2f",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Rum",
    },
    talavera: {
        code: "#2b3b55",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Talavera",
    },
    atlantic: {
        code: "#16618c",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Atlantic",
    },
    kingfisher: {
        code: "#017eb4",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Kingfisher",
    },
    rio: {
        code: "#99d3f3",
        mode: { dark: false, standard: true },
        deprecated: true,
        displayName: "Rio",
    },
    caspian: {
        code: "#204949",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Caspian",
    },
    celtic: {
        code: "#046240",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Celtic",
    },
    emerald: {
        code: "#0a806b",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Emerald",
    },
    mediumGreen: {
        code: "#318643",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Medium Green",
    },
    opal: {
        code: "#c0e6df",
        mode: { dark: false, standard: true },
        deprecated: true,
        displayName: "Opal",
    },
    black900: {
        code: "#000000",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Black",
    },
    graphite: {
        code: "#313131",
        mode: { dark: true, standard: false },
        deprecated: true,
        displayName: "Graphite",
    },
    mediumGrey: {
        code: "#dfdfdf",
        mode: { dark: false, standard: true },
        deprecated: true,
        displayName: "Medium Grey",
    },
    platinum: {
        code: "#efefef",
        mode: { dark: false, standard: true },
        deprecated: true,
        displayName: "Platinum",
    },
};
export const MARKETING_COLORS = Object.assign(Object.assign(Object.assign({}, MARKETING_COLORS_CORE), MARKETING_COLORS_BRAND), MARKETING_COLORS_HOLIDAY);
